import React, { useState } from "react";
import WebsiteLayout from "../layouts/WebsiteLayout";
import Banner from "../components/Banner";
import { useQuery } from "@tanstack/react-query";
import { getVideos } from "../api/gallery.api";
import { Modal } from "react-bootstrap";
import { queryError } from "../utils/helpers";

let banner = require("../assets/images/gallery.jpeg");

const BottleGallery = () => {
  const { data } = useQuery(['public-videos'], getVideos, {
    onError: () => queryError()
  });

  const videos = data?.value || [];
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [slideshowMode, setSlideshowMode] = useState(false);
  const [slideshowIndex, setSlideshowIndex] = useState(0);

  const openSlideshow = (startIndex) => {
    setSlideshowIndex(startIndex);
    setSlideshowMode(true);
  };

  const closeSlideshow = () => {
    setSlideshowMode(false);
  };

  const nextSlide = () => {
    setSlideshowIndex((prev) => (prev + 1) % videos.length);
  };

  const prevSlide = () => {
    setSlideshowIndex((prev) => (prev - 1 + videos.length) % videos.length);
  };

  return (
    <WebsiteLayout>
      <Banner title="Bottle Breaking Gallery" link="Bottle Gallery" bannerImage={banner} />
      <section className="sb-menu-section sb-p-90-90">
        <div className="sb-bg-1">
          <div />
        </div>
        <div className="container">
          {videos.length > 0 && (
            <div className="text-center sb-mb-30">
              <button
                className="sb-btn sb-btn-2 sb-btn-gray"
                onClick={() => openSlideshow(0)}
                style={{ cursor: "pointer" }}
              >
                <span className="sb-icon">
                  <i className="fas fa-play"></i>
                </span>
                <span>Play Slideshow</span>
              </button>
            </div>
          )}

          <div className="sb-masonry-grid">
            <div className="sb-grid-sizer" />
            {videos.length > 0 ? (
              videos.map((video, index) => (
                <div key={video._id} className="sb-grid-item sb-item-33">
                  <div className="sb-menu-item sb-mb-30">
                    <div className="sb-card-tp">
                      <h4 className="sb-card-title">{video.title}</h4>
                    </div>
                    <div style={{ position: "relative", cursor: "pointer", background: "#000" }}
                         onClick={() => setSelectedVideo(video)}>
                      <video
                        src={video.videoUrl}
                        style={{ width: "100%", height: "220px", objectFit: "contain" }}
                        muted
                        preload="metadata"
                      />
                      <div style={{
                        position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        background: "rgba(0,0,0,0.3)"
                      }}>
                        <i className="fas fa-play-circle" style={{ fontSize: 48, color: "#fff" }}></i>
                      </div>
                    </div>
                    <div style={{ padding: "10px 0", textAlign: "center" }}>
                      <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => setSelectedVideo(video)}>
                        <i className="fas fa-play"></i> Watch
                      </button>
                      <button className="btn btn-sm btn-outline-secondary" onClick={() => openSlideshow(index)}>
                        <i className="fas fa-images"></i> Slideshow
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <h4 className="text-center w-100">No videos available at the moment.</h4>
            )}
          </div>
        </div>
      </section>

      {/* Single video modal */}
      <Modal show={selectedVideo !== null} onHide={() => setSelectedVideo(null)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{selectedVideo?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: "#000", padding: 0 }}>
          {selectedVideo && (
            <video
              src={selectedVideo.videoUrl}
              controls
              autoPlay
              style={{ width: "100%", maxHeight: "70vh", objectFit: "contain" }}
            />
          )}
        </Modal.Body>
      </Modal>

      {/* Slideshow modal */}
      <Modal show={slideshowMode} onHide={closeSlideshow} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {videos[slideshowIndex]?.title} &nbsp;
            <small style={{ color: "#999" }}>({slideshowIndex + 1} / {videos.length})</small>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: "#000", padding: 0, position: "relative", minHeight: 300 }}>
          {videos.length > 0 && (
            <>
              <video
                key={videos[slideshowIndex]?._id}
                src={videos[slideshowIndex]?.videoUrl}
                controls
                autoPlay
                style={{ width: "100%", maxHeight: "70vh", objectFit: "contain" }}
              />
              {/* Nav arrows */}
              <button
                onClick={prevSlide}
                style={{
                  position: "absolute", top: "50%", left: 10, transform: "translateY(-50%)",
                  background: "rgba(255,255,255,0.7)", border: "none", borderRadius: "50%",
                  width: 44, height: 44, fontSize: 20, cursor: "pointer", zIndex: 10
                }}
              >
                <i className="fas fa-chevron-left"></i>
              </button>
              <button
                onClick={nextSlide}
                style={{
                  position: "absolute", top: "50%", right: 10, transform: "translateY(-50%)",
                  background: "rgba(255,255,255,0.7)", border: "none", borderRadius: "50%",
                  width: 44, height: 44, fontSize: 20, cursor: "pointer", zIndex: 10
                }}
              >
                <i className="fas fa-chevron-right"></i>
              </button>
            </>
          )}
        </Modal.Body>
      </Modal>
    </WebsiteLayout>
  );
};

export default BottleGallery;
